import {nanoid} from "nanoid";
import { DownCircleOutlined, FireOutlined, UserOutlined, BankOutlined, RetweetOutlined } from '@ant-design/icons';

const stats = [
    {
        id: nanoid(),
        icon: <DownCircleOutlined />,
        title: "Registrated Users",
        name: "registratedUsersCount",
    },
    {
        id: nanoid(),
        icon: <FireOutlined />,
        title: "Active Missions",
        name: "activeMissionsCount",
    },
    {
        id: nanoid(),
        icon: <UserOutlined />,
        title: "Clients",
        name: "clientsCount",
    },
    {
        id: nanoid(),
        icon: <BankOutlined />,
        title: "Delegates",
        name: "delegatesCount",
    },
    {
        id: nanoid(),
        icon: <RetweetOutlined />,
        title: "Pending",
        name: "pendingCount",
    },
];

const missionActiveStatuses = [2, 4, 5, 6];

export const getRegisteratedUsers = (users) => users?.length;

export const getActiveMissions = (users, missions) => {
    if(users === undefined) {
        return users
    }
    const usersId = users.map(({id}) => id);
    const data = missions.filter(({uid, did}) => usersId.includes(uid) || usersId.includes(did))
    return data.filter(({status}) => missionActiveStatuses.includes(status)).length;
;}

export const getClients = (users) => {
    if(users === undefined) {
        return users
    }
    return users.filter(({type}) => type === 2 || type === 3).length;
}

export const getDelegates = (users) => {
    if(users === undefined) {
        return users
    }
    return users.filter(({type}) => type === 1).length;
}

export const getPendingUsers = (users) => {
    if(users === undefined) {
        return users
    }
    return users.filter(({approve}) => approve === 0).length
}

export const searchFunction = (data, value) => {
    const search = value.toLowerCase();
    const hits = data.hits.filter(({name, email, phone}) => {
        return name.toLowerCase().includes(search) || email.toLowerCase().includes(search) || phone.toLowerCase().includes(search)
    })
    return {...data, hits}
}

export const createAddressOptions = ((data = []) => {
    const unique = new Set(data);
    return [...unique].map(value => ({value, text: value, id: nanoid()}));
});

export const getResultData = (data, search, countries = [], cities = []) => {
    const searchData = search ? searchFunction(data, search) : data;
    const countryHits = countries.length ? searchData.hits.filter(({address_country}) => countries.includes(address_country)) : searchData.hits;
    const cityHits = cities.length ? countryHits.filter(({address_city}) => cities.includes(address_city)) : countryHits;
    return {...searchData, hits: cityHits};
}

export default stats;
